import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import {
  emptyShipmentSummaryBase,
  getEffectiveShipmentSummaryBase,
  ShipmentSummary,
} from "@redotech/redo-fulfillment-group-common/shipment-summary";
import {
  canVoidFreight,
  getLabelVoidability,
} from "@redotech/redo-fulfillment-operations-common/fulfillment-group-utils";
import { groupClaimActionSummary } from "@redotech/redo-package-protection-common/shipping-claims/shipping-claim";

/** Cutover shim: falls back to the deprecated shipment fields when the backend
 * predates shipmentSummary; delete once the cutover completes. */
export function getEffectiveShipmentSummary(
  data: FulfillmentGroupData | undefined,
): ShipmentSummary | null {
  if (!data) {
    return null;
  }
  if (data.shipmentSummary) {
    return data.shipmentSummary;
  }
  const base = getEffectiveShipmentSummaryBase(data);
  const freightShipment = data.shipmentDetails?.freightShipment;
  if (!base && !freightShipment) {
    return null;
  }
  return {
    ...(base ?? emptyShipmentSummaryBase()),
    voidActionSummary: getLabelVoidability(data),
    claimActionSummary: groupClaimActionSummary(data),
    freight: freightShipment
      ? {
          trackingCode: freightShipment.tracker.trackingCode,
          trackingUrl: freightShipment.tracker.publicUrl,
          scac: freightShipment.scac,
          cost: {
            amount: freightShipment.cost,
            currency: freightShipment.currency,
          },
          hasBol: !!freightShipment.billOfLadingUrl,
          canVoid: canVoidFreight(data),
        }
      : null,
  };
}
